import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class HeaderService {
  onScroll: ReplaySubject<any> = new ReplaySubject<any>();

  constructor() {}
}
